"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordSchema = void 0;
var loan_detail_schema_1 = require("./loan-detail-schema");
var property_schema_1 = require("./property-schema");
var record_status_code_1 = require("./record-status-code");
var record_validation_result_schema_1 = require("./record-validation-result-schema");
var recovery_status_code_1 = require("./recovery-status-code");
exports.recordSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'recordID',
        'approvedLenderCode',
        'recordCreatedTimestamp',
        'recordCreatedUserID',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'reportingPeriodID',
        'reportingPeriod',
        'statusCode',
    ],
    properties: {
        recordID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        arrearsFileID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        approvedLenderCode: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'should have be of length 5 characters',
        },
        approvedLenderCurrentReferenceNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters or null',
        },
        approvedLenderName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 35,
            errorMessage: 'should have variable length up to 35 characters or null',
        },
        approvedLenderOriginalReferenceNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters or null',
        },
        arrearsReasonCode: {
            type: ['string', 'null'],
            minLength: 0,
            // maxLength: 2, TODO: Pending on conversation to reintroduce enum validation on the arrears csv file
            errorMessage: 'should have variable length up to 2 characters or null',
        },
        borrowerFirstName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have variable length up to 15 characters or null',
        },
        borrowerLastName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 25,
            errorMessage: 'should have variable length up to 25 characters or null',
        },
        cmhcLoanAccountNumber: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        coBorrowerFirstName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have variable length up to 15 characters or null',
        },
        coBorrowerLastName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 25,
            errorMessage: 'should have variable length up to 25 characters or null',
        },
        contactMadeWithBorrowerIndicator: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have variable length up to 2 characters or null',
        },
        currentInterestRatePercent: {
            type: ['number', 'null'],
            maximum: 999999,
            minimum: 0,
            multipleOf: 0.0001,
            errorMessage: 'should be a decimal with up to 10 digits in total and 4 digits of precision or null',
        },
        daysInArrearsCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        decisionTypeCode: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        financialInstitutionCode: {
            type: ['string', 'null'],
            minLength: 3,
            maxLength: 3,
            errorMessage: 'should be a string of length 3 characters or null',
        },
        lastCompleteInstallmentPaidDueDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        loanDetail: loan_detail_schema_1.loanDetailSchema,
        outstandingPrincipalBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        paymentFrequencyTypeCode: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        property: property_schema_1.propertySchema,
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recoveryStatusCode: {
            type: ['string', 'null'],
            enum: Object.values(recovery_status_code_1.RecoveryStatusCode),
            errorMessage: 'Should equate to a valid RecoveryStatusCode Enum value or null',
        },
        remarkText: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 5000,
            errorMessage: 'should have variable length up to 5000 characters or null',
        },
        reportingPeriodID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        reportingPeriod: {
            type: 'string',
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD',
        },
        statusCode: {
            type: 'number',
            enum: Object.values(record_status_code_1.RecordStatusCode),
            errorMessage: 'Should equate to a valid RecordStatusCode Enum value',
        },
        statusUpdatedTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        statusUpdatedUserID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        totalArrearsAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        transitNumber: {
            type: ['string', 'null'],
            minLength: 5,
            maxLength: 5,
            errorMessage: 'should be a string of length 5 characters or null',
        },
        validationResults: {
            type: ['array', 'null'],
            items: record_validation_result_schema_1.recordValidationResultSchema,
        },
    },
};
